import React from 'react'
import { siteScrollImg, partner1, partner2, partner3, partner4, partner5 } from '../../asserts/images'

const Partners = () => {
  return (
    <div className="container-fluid p-0">
            <div>
              <div class="marquee-container trusted-partnerContainer">
                <div class="marquee">
                <div class="trustedPartners">
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner1} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner2} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner3} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner4} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner5} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner1} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner2} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner3} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner4} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner5} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner1} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner2} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner3} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner4} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner5} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner1} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner2} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner3} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner4} alt=""></img>
                    </div>
                    <div class="trustedPartner ">
                      <img draggable={false} src={partner5} alt=""></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </div>
  )
}

export default Partners